export const generateControlledColor = (label, controleCores) => {
    const found = controleCores.find(item => item === label)
    if (found) return found.color

    let newColor
    do {
        newColor = '#' + Math.floor(Math.random() * 0xffffff)
            .toString(16)
            .padStart(6, '0')
            .toLowerCase()
    } while (controleCores.some(item => item.color === newColor))

    return newColor
}

export const generateSingleColor = () => {
    return '#' + Math.floor(Math.random() * 0xffffff)
        .toString(16)
        .padStart(6, '0')
        .toLowerCase()
}